module.exports = __webpack_public_path__ + "img/discharge.79f772db.svg";